Object.defineProperty(exports, '__esModule', { value: true });

var constants = require('../constants.js');
var index_module = require('../index.module-e39cc256.js');

var isBackgroundToken = function (token) { return token && constants.BACKGROUND.includes(token); };
var getClasses = function (backgroundColor, borderColor, borderSize, shadow) {
    var _a;
    return (_a = {},
        _a[index_module.styles["background-".concat(backgroundColor)]] = isBackgroundToken(backgroundColor),
        _a[index_module.styles["border-color-".concat(borderColor)]] = borderColor,
        _a[index_module.styles["border-width-".concat(borderSize)]] = borderSize,
        _a[index_module.styles["".concat(shadow)]] = shadow,
        _a);
};

exports.getClasses = getClasses;
exports.isBackgroundToken = isBackgroundToken;
